import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'react'

/**
 * Standard app content shell:
 * max-width 1440px with 32px (px-8) horizontal padding on each side.
 */
export function PageContainer({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-[1440px] px-8', className)}
      {...props}
    >
      {children}
    </div>
  )
}
